import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<
  string,
  {
    embed?: boolean;
    scaleBgOnMobile?: boolean;
    boxShadow?: boolean;
    isMaximizer?: boolean;
    src?: string;
    isMobile?: boolean;
  }
>(
  () => ({
    root: ({ isMaximizer, boxShadow }) => ({
      position: 'relative',
      boxShadow: boxShadow ? `2px 21px 32px 40px rgba(237,233,232,1)` : '',

      '@media screen and (max-width: 1490px)': {
        maxHeight: isMaximizer ? 532 : 'none',
      },

      '@media screen and (max-width: 1024px)': {
        '&&': {
          boxShadow: boxShadow ? `2px 12px 40px 24px rgba(237,233,232,1)` : '',
          background: isMaximizer ? '#ede9e8' : 'none',
          maxHeight: 'none',
        },
      },
    }),
    centeredContent: {
      '@media screen and (max-width: 1024px)': {
        '&&': {
          paddingTop: Spacings.s0,
        },
        '& > div': {
          display: 'flex',
          flexDirection: 'column',
          padding: Spacings.s0,
          height: '100%',
        },
      },
    },
    wrapper: {
      display: 'flex',
      maxWidth: props => (props?.embed ? '100%' : '50%'),

      '& *': {
        zIndex: 1,
      },

      '&.thin': {
        minHeight: 158,
        maxWidth: 758,
      },

      '&.left': {
        justifyContent: 'baseline',
        marginLeft: Spacings.s0,
        marginRight: 'auto',
      },

      '&.right': {
        justifyContent: 'end',
        marginLeft: 'auto',
        marginRight: Spacings.s0,
      },

      '&.center': {
        justifyContent: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',

        '@media screen and (max-width: 1024px)': {
          order: props => props.isMaximizer && 1,
          flexDirection: props => props.isMaximizer && 'column',
          maxWidth: props => props.isMaximizer && '100%',
        },
      },

      [mediaQuery(1023)]: {
        '&&': {
          maxWidth: 456,
          gridTemplateColumns: '100%',
          gap: Spacings.s32,
        },

        '&.left, &.right, &.center': {
          justifyContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        },
      },
    },
    contentAndVideo: ({ isMaximizer }) => ({
      display: 'grid',
      gap: Spacings.s40,

      '&.left, &.right': {
        width: '50%',

        [mediaQuery(1023)]: {
          width: '100%',
        },
      },
      ...(isMaximizer && {
        '@media screen and (max-width: 1024px)': {
          paddingTop: Spacings.s12,
        },
      }),
    }),
    content: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',

      '&.left': {
        textAlign: 'left',
      },

      '&.right': {
        textAlign: 'right',
      },
    },
    action: {
      width: 'fit-content',

      '&.left': {
        justifySelf: 'flex-start',
      },

      '&.center': {
        justifySelf: 'center',
      },

      '&.right': {
        justifySelf: 'flex-end',
      },

      [mediaQuery(1023)]: {
        margin: [Spacings.s0, 'auto'],
      },
    },
    video: {
      width: '100%',
      margin: [0, Spacings.s32],

      [mediaQuery(1023)]: {
        margin: [0, Spacings.s16],
      },
    },
    imageHolder: ({ isMaximizer }) => ({
      position: 'absolute',
      left: Spacings.s0,
      top: Spacings.s0,
      width: '100%',
      height: '100%',
      zIndex: 0,
      '@media screen and (max-width: 1024px)': {
        position: isMaximizer && 'unset',
      },
    }),
    picture: {
      maxWidth: '100%',
      overflow: 'hidden',
    },
    image: {
      [mediaQuery(1023)]: {
        transform: props => props.scaleBgOnMobile && 'scale(4, 1) translateX(100px)',
      },
    },

    //  SKELETON
    rootFallback: {
      borderBottom: `1px solid ${BackgroundColors.base}`,
      backgroundColor: BackgroundColors.base,
    },
    contentFallback: {
      flexDirection: 'column',
    },
    subTitleFallback: {
      height: 24,
      width: 400,
      marginBottom: Spacings.s8,
    },
    titleFallback: {
      height: 72,
      width: 456,
    },
    descriptionFallback: {
      height: 48,
      width: 456,
    },
    actionFallback: {
      width: 250,
      height: 56,
    },
  }),
  {
    name: 'banner-with-wallpaper',
  },
);

export default useStyles;
